var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"loading"}},[(_vm.show)?_c('div',{staticClass:"modal active"},[_c('div',{staticClass:"modal-overlay"}),_c('div',{staticClass:"loading",class:_vm.sizeClass})]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }